/*!
 * (c) 2026 Ocean Essentials Limited (HK). All rights reserved.
 * Exocet Pointer — magnetic CTA. Opt-in via data-magnetic on a single primary button.
 * Desktop + fine-pointer only (never on touch), and skipped under reduced-motion.
 * Restraint by design: a small pull on the conversion button, nothing else.
 */
(function () {
  "use strict";

  var BOUND = "data-magnetic-bound";
  var STRENGTH = 0.3; // fraction of the cursor offset from the button centre
  var MAX = 10; // px cap on the pull

  function supports() {
    return (
      typeof gsap !== "undefined" &&
      window.matchMedia("(pointer: fine)").matches &&
      window.matchMedia("(min-width: 750px)").matches &&
      !window.matchMedia("(prefers-reduced-motion: reduce)").matches
    );
  }

  function clamp(value) {
    return Math.max(-MAX, Math.min(MAX, value));
  }

  function bind(el) {
    if (el.hasAttribute(BOUND)) return;
    el.setAttribute(BOUND, "");

    var xTo = gsap.quickTo(el, "x", { duration: 0.4, ease: "power3" });
    var yTo = gsap.quickTo(el, "y", { duration: 0.4, ease: "power3" });

    function move(event) {
      var rect = el.getBoundingClientRect();
      xTo(clamp((event.clientX - rect.left - rect.width / 2) * STRENGTH));
      yTo(clamp((event.clientY - rect.top - rect.height / 2) * STRENGTH));
    }

    function reset() {
      xTo(0);
      yTo(0);
    }

    el.addEventListener("pointermove", move);
    el.addEventListener("pointerleave", reset);

    el._magneticCleanup = function () {
      el.removeEventListener("pointermove", move);
      el.removeEventListener("pointerleave", reset);
      gsap.set(el, { x: 0, y: 0 });
      el.removeAttribute(BOUND);
    };
  }

  function init(root) {
    root.querySelectorAll("[data-magnetic]").forEach(bind);
  }

  function boot(root) {
    if (!supports()) return;
    init(root);
  }

  function onReady() {
    boot(document);
  }

  if (document.readyState === "loading") {
    document.addEventListener("DOMContentLoaded", onReady);
  } else {
    onReady();
  }

  if (typeof Shopify !== "undefined" && Shopify.designMode) {
    document.addEventListener("shopify:section:load", function (event) {
      boot(event.target);
    });
  }

  window.ExocetPointer = {
    refresh: function () {},
    boot: boot,
  };

  if (window.ExocetMotion) {
    ExocetMotion.register(window.ExocetPointer);
  }
})();
